// extracted by mini-css-extract-plugin
export var pillWrapper = "_pp-0";
export var showOverflow = "_pp-1";